import React, { Component, PropTypes } from 'react';
import { readComponentInstanceResourceList } from '../../lib/frankly';
import { DataStoreDispatcher } from '../../lib/frankly';
import store from 'store';
import classNames from 'classnames';
import translate from '../../utils/translate';

const TRANSITION_ABOVE_BREAKPOINT = 992;

/**
 * Class representing the a snapshot of the current weather conditions
 *
 * Dependent on
 * - GET /api/integrations/wsi/current
 * - GET /api/integrations/wsi/current?zipcode=${zipcode}
 */

class CurrentConditionsAtAGlance extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    link: PropTypes.string,
    showCityName: PropTypes.bool,
    transitionTimeInSeconds: PropTypes.number,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    textSize: PropTypes.oneOf(['large']),
    iconSize: PropTypes.oneOf(['large']),
    condensed: PropTypes.bool,
    showDetail: PropTypes.bool

  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    showCityName: false,
    transitionTimeInSeconds: 3,
    textColor: '#000'
  }

  constructor(props) {
    super(props);

    this._weatherDataStoreDispatcher = null;
    this._locationWeatherData = [];
    this._locations = [];
    this._transitionIntervalId = null;
  }

  state = {
    temperatureFormat: 'F',
    activeIndex: 0
  }

  componentWillMount() {
      if (process.env.BROWSER) {
        const {FRN_rawResponses = [{data: {}}]} = this.props;
        const data = FRN_rawResponses.data;

        this._locations = this._getLocations();

        if (!data || (typeof data === 'object' && data === {})) {
          this._getWeatherForZipcode(0, this._locations[0].zipcode);
        } else {
          this._setLocationWeatherInfo(this.state.activeIndex, data); // activeIndex === 0 at this point
        }

        // //Prefetch the next weather data:
        if (this._locations[1]){
            this._getWeatherForZipcode(1, this._locations[1].zipcode);
        }

        this._weatherDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/weather');

        this._weatherDataStoreDispatcher.onChange('temperatureFormat', (val) => {
            this.setState({
                temperatureFormat: val
            });
        });
    }
  }

  componentDidMount() {
    const { transitionTimeInSeconds } = this.props;
    if (transitionTimeInSeconds > 0 && window.innerWidth > TRANSITION_ABOVE_BREAKPOINT) { 
      this._startAutoChangeInterval(transitionTimeInSeconds);
    }
  }

  componentWillUnmount() {
    this._weatherDataStoreDispatcher.off();
    this._weatherDataStoreDispatcher = null;
    clearInterval(this._transitionIntervalId);
  }

  _startAutoChangeInterval(transitionTimeInSeconds) {
    this._transitionIntervalId = setInterval(() => {
      const {
        activeIndex
      } = this.state;
      const nextIndex = (activeIndex + 1) % this._locations.length;

      if (this._locations[nextIndex]) {
        this._onChange(nextIndex);
      }
    }, transitionTimeInSeconds * 1000);
  }

  _getWeatherForZipcode(index, zipcode) {
    readComponentInstanceResourceList(this, { propPath: `zipcodeData`, vars: { zipcode } }).then(rawresponse => {
      this._setLocationWeatherInfo(index, rawresponse[0].data);
    }).catch(error => {
      console.log('Error fetching data', error);
    });
  }

  _onChange(index) {
    const nextIndex = (index + 1) % this._locations.length;

    this.setState({ activeIndex: index});

    //Pre fetch the next set of data if we haven't got it
    if (!this._locationWeatherData[nextIndex]) {
      this._getWeatherForZipcode(nextIndex, this._locations[nextIndex].zipcode);
    }
  }

  _getLocations() {
    const {
      affiliate: {
        locations: stationLocations = []
      } = {}
    } = this.context.config;
    const userLocations = store.get('_locations') || [];

    return [...userLocations, ...stationLocations];
  }

  _setLocationWeatherInfo(index, data) {
      if (data) {
        this._locationWeatherData[index] = data;
        
        if (index === 0) {
          this.setState({ activeIndex: index });
        }
      }
  }

  render() {
    const {
      config: {
        appOptions: {
          language = 'en'
        } = {}
      } = {}
    } = this.context;
    
    const {
      link = '',
      showCityName,
      backgroundColor,
      textColor,
      textSize,
      iconSize,
      condensed,
      showDetail
    } = this.props;

    const {
      temperatureFormat,
      activeIndex
    } = this.state;

    const activeWeatherData = this._locationWeatherData[activeIndex];

    if (!activeWeatherData) {
      return null;
    }

    const {
      tempF,
      tempC,
      iconCode,
      sky,
      hiTempF,
      loTempF
    } = activeWeatherData;

    const {
      city: cityName = ''
    } = this._locations[activeIndex];

    const styleOfWrapper = {
      display: condensed ? 'none' : null
    };
    const weatherLocation = [];
    const weatherInfo = [];
    if (!showDetail) {
      weatherLocation.push(<div key={weatherLocation.length} className={classNames('CurrentConditionsAtAGlance-cityName', {[`CurrentConditionsAtAGlance-cityName--${textSize}`]: textSize})}>{cityName}</div>);
      weatherInfo.push(
        <span key={weatherInfo.length} className={classNames('CurrentConditionsAtAGlance-temp', {[`CurrentConditionsAtAGlance-temp--${textSize}`]: textSize})} >{(temperatureFormat === 'F' ? tempF : tempC) + '°'}</span>
        );
    } else {
      weatherLocation.push(
        <div key={weatherLocation.length} className={classNames('CurrentConditionsAtAGlanceDetail-wrapper')} style={styleOfWrapper}>
          <div className={classNames('CurrentConditionsAtAGlanceDetail-wrapper-cityName')}>{cityName}</div>
          <div className={classNames('CurrentConditionsAtAGlanceDetail-wrapper-sky')}>{sky}</div>
        </div>
      );
      weatherInfo.push(
        <div key={weatherInfo.length} className={classNames('CurrentConditionsAtAGlanceDetail-wrapper')} style={styleOfWrapper}>
          <div className="CurrentConditionsAtAGlanceDetail-wrapper-sky"><span className="CurrentConditionsAtAGlanceDetail-wrapper-cityName">{translate('H', language)} </span>{`${hiTempF}°`}</div>
          <div className="CurrentConditionsAtAGlanceDetail-wrapper-sky"><span className="CurrentConditionsAtAGlanceDetail-wrapper-cityName">{translate('L', language)} </span>{`${loTempF}°`}</div>
        </div>
      );
    }
    const classNameOfCurrentConditionsAtAGlance = showDetail ? 'CurrentConditionsAtAGlanceDetail' : 'CurrentConditionsAtAGlance';
    const currentConditionsContents = [
      (showCityName ?
      weatherLocation
      : null),
      <div className={classNames(`${classNameOfCurrentConditionsAtAGlance}-weatherInfo`, {'CurrentConditionsAtAGlanceDetail-weatherInfo--condensed': condensed})} key={weatherLocation.length}>
        {showDetail &&
          <span className={classNames(`${classNameOfCurrentConditionsAtAGlance}-temp`, {'CurrentConditionsAtAGlanceDetail-temp--condensed': condensed})} >{(temperatureFormat === 'F' ? tempF : tempC) + '°'}</span>
        }
        <span className={classNames('weather-icon', `weather-icon-${iconCode}`, {[`weather-icon--${iconSize}`]: !condensed})}/>
        {weatherInfo}
      </div>
    ];
    const currentConditionsLink = link ? (
      <a className="CurrentConditionsAtAGlance-link" href={link}>
        {currentConditionsContents}
      </a>
    ) : null;

    if (!iconCode || !(tempF || tempC)) {
      return null;
    }

    return (
      <div className={classNames(`${classNameOfCurrentConditionsAtAGlance}`)} style={{color: textColor, backgroundColor}}>
        {currentConditionsLink || currentConditionsContents}
      </div>
    );
  }
}

export default CurrentConditionsAtAGlance;



// WEBPACK FOOTER //
// ./app/components/weather/CurrentConditionsAtAGlance.js